import {Lang} from 'yougile-lang'
import {logger} from 'yougile-util'
import {DataObjectId, Hub} from 'yougile-model'
import {Notifier} from '@api/model/notifier'
import {Sync} from '@client/sync'
import {Backend} from '@common/backend'
import {Tracking, TrackingEvent} from '@common/tracking'
import {globals} from '@extensions/globals-base'
import {canCreateMirroredTaskWithError} from './can-create-mirrored-task'

export const url = '/data/mirrored-task/create-mirrored-task'

export const createMirroredTask = async (
  task: Hub,
  location?: DataObjectId
): Promise<void> => {
  const result = await createMirroredTaskById({
    taskId: task.id,
    location,
    type: 'near'
  })
  if (!result?.status) {
    logger.error('Cannot create-mirrored-task', result?.errorDetails)
    Notifier.error(Lang.msg.mirroredTasks.taskMirrorFailed)
  } else {
    Notifier.success(Lang.msg.mirroredTasks.taskMirrorSuccess)
  }
}

export interface CreateMirroredTaskProps {
  taskId: DataObjectId
  location?: DataObjectId
  type: 'near' | 'specified'
  addAfterHubId?: DataObjectId
  after?: boolean
}

interface CreateMirroredTaskResult {
  status: boolean
  errorDetails?: string
}

export const createMirroredTaskById = async (
  props: CreateMirroredTaskProps
): Promise<CreateMirroredTaskResult> => {
  const {taskId, location, type, addAfterHubId, after} = props

  const companyId = globals.getCompanyId()

  const box = Sync.getCurrentSandbox()
  const task = box.getHub(taskId)

  if (!task || !location || !companyId || !taskId) {
    return {status: false, errorDetails: 'Invalid task or location'}
  }

  if (!canCreateMirroredTaskWithError({taskId, location})) {
    return {status: false, errorDetails: 'Cannot create mirrored task'}
  }

  try {
    const result = await Backend.postJSON<CreateMirroredTaskResult>(url, {
      ...Backend.loadCred(),
      companyId,
      taskId,
      type,
      location,
      addAfterHubId,
      after
    })

    void Tracking.send(TrackingEvent.taskMirrorCreate)
    return result
  } catch (e) {
    logger.error('Cannot create-task-mirror', e)
    return {status: false, errorDetails: 'Cannot create mirrored task'}
  }
}
